import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import HairQuiz from "./pages/HairQuizPage";
import { CartProvider } from "./context/CartContext";
import ConsultationPage from "./pages/ConsultationPage";
import HairJournalPage from "./pages/HairJournalPage";
import FAQ from "./pages/FAQ";
import ShippingPolicy from "./pages/ShippingPolicy";
import ReturnsExchanges from "./pages/ReturnsExchanges";
import ScrollToTop from "./components/utils/ScrollToTop";
import Tips from "./pages/Tips";
import OrderConfirmation from "./pages/OrderConfirmation";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <CartProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/hair-quiz" element={<HairQuiz />} />
            <Route path="/consultation" element={<ConsultationPage />} />
            <Route path="/hair-journal" element={<HairJournalPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/returns-exchanges" element={<ReturnsExchanges />} />
            <Route path="/tips" element={<Tips />} />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </CartProvider>
    </Router>
  );
}
